export interface IRulesTable {
  id?: number;
  description?: string | null;
}

export const defaultValue: Readonly<IRulesTable> = {};
